import React, { FunctionComponent } from "react";

import { isPricingEnabled } from "../../../../hooks/useAllowPartPricing";
import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { useIsLoggedOn } from "../../../../stores/hooks/useIsLoggedOn";
import { useNullableDealerAccountInfo } from "../../../../stores/hooks/useNullableDealerAccountInfo";
import { PriceDisplay } from "../../../../ui/PriceDisplay/PriceDisplay";

export const PartPrice: FunctionComponent<{
  part: TirePartItem | WheelPartItem;
  quantity: number;
}> = ({ part, quantity }) => {
  const dealer = useNullableDealerAccountInfo();
  const isLoggedOn = useIsLoggedOn();

  const displayPrice = Number(
    part.partPricing.primaryPart.price[quantity]?.contextList[0].displayPrice
  );

  if (!isPricingEnabled({ dealer, displayPrice, isLoggedOn, part })) {
    return null;
  }

  return <PriceDisplay>{displayPrice}</PriceDisplay>;
};
